/**
 * V3.6.2 是否待分摊（shareType）公共常量
 * 预算编制、年度预算调整等模块共用，枚举值与后端 shareTypeNo 保持一致。
 *
 * 业务规则：
 * - 历史存量数据无 shareType 时，前端/后端均按「否」(1) 处理
 * - 仅 shareTypeNo=3（分摊出去）允许金额为负数（后端校验，前端透传）
 */

/** 默认分摊类型：否。历史数据及未传值时的兜底值 */
export const defaultShareTypeNo = 1

/** 下拉选项：value 对应 shareTypeNo，label 对应 shareType 展示文案 */
export const SHARE_TYPE_OPTIONS = [
  { value: 1, label: '否' },
  { value: 2, label: '是（待分摊）' },
  { value: 3, label: '是（分摊出去）' },
  { value: 4, label: '是（分摊进来）' },
]

/**
 * 根据 shareTypeNo 获取展示文案
 * @param {number|string} shareTypeNo
 * @returns {string}
 */
export function getShareTypeLabel(shareTypeNo) {
  const item = SHARE_TYPE_OPTIONS.find(function (opt) {
    return String(opt.value) === String(shareTypeNo)
  })
  return item ? item.label : ''
}

/**
 * 规范化 shareTypeNo：空值按历史数据规则默认为「否」
 * @param {number|string|null|undefined} shareTypeNo
 * @returns {number}
 */
export function normalizeShareTypeNo(shareTypeNo) {
  if (shareTypeNo === null || shareTypeNo === undefined || shareTypeNo === '') {
    return defaultShareTypeNo
  }
  return Number(shareTypeNo)
}

/**
 * 透视表动态列 key：事业部改为非必填后，空事业部统一映射为 '' 作为列 prop
 * V3.6.2 唯一性维度：事业部 + 是否待分摊 + 预算大类 + 预算类型（后端校验）
 * @param {number|string|null|undefined} businessUnitId
 * @returns {string} 列 prop，空事业部返回 ''
 */
export function getBusinessUnitColumnKey(businessUnitId) {
  if (businessUnitId === null || businessUnitId === undefined || businessUnitId === '') {
    return ''
  }
  return String(businessUnitId)
}
